import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "../lib/analytics";

function AnalyticsTracker(): null {
  const location = useLocation();

  useEffect(() => {
    // Construct a URL object from the location
    // The base URL doesn't matter here as we only use pathname, search, and hash
    const currentUrl = new URL(location.pathname + location.search + location.hash, window.location.origin);
    pageview(currentUrl);
  }, [location]);

  return null;
}

export default AnalyticsTracker; 